module.exports = __webpack_public_path__ + "img/n_starev.d7550829.jpg";